import { render } from "./FlowActionsList.vue?vue&type=template&id=56da7f82"
import script from "./FlowActionsList.vue?vue&type=script&lang=js"
export * from "./FlowActionsList.vue?vue&type=script&lang=js"
script.render = render

export default script